import React from "react";
import { motion } from "framer-motion";
import ArrowSVG from "../../home/components/arrowSvg";

const CallToActionButton = ({
  text,
  color,
  id
}) => {

  const onClick = () => {
    window.open("https://calendly.com/gantus-nicolas/30min", '_blank');
  };

  return(
    <motion.button 
      onClick={onClick}
      id={id}
      className="call-to-action-button"
      type="button" 
      style={{ backgroundColor: color }}
      initial={{ scale: 1 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
    >
      {text}
      <ArrowSVG />
    </motion.button>
  );
};

export default CallToActionButton;